import React from "react";

import clsx from "clsx";

import navStyles from "../styles";

const buildNumber = process.env.BUILD_NUMBER || "local";

const DisplayVersion = () => {
  const classes = navStyles();

  return (
    <span
      style={{
        color: "inherit",
        fontVariant: "body2",
      }}
      className={clsx(classes.versionDisplay)}
    >
      <b>{buildNumber === "local" ? buildNumber : `#${buildNumber}`}</b>
    </span>
  );
};

export default DisplayVersion;
